module.exports = __webpack_public_path__ + "media/images/light_grey_background-37ae9de020af4ba23eba6032907749d0.svg";